import { render, staticRenderFns } from "./RetestSubmitForm.vue?vue&type=template&id=ab0a1aba&scoped=true"
import script from "./RetestSubmitForm.vue?vue&type=script&lang=js"
export * from "./RetestSubmitForm.vue?vue&type=script&lang=js"
import style0 from "./RetestSubmitForm.vue?vue&type=style&index=0&id=ab0a1aba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab0a1aba",
  null
  
)

export default component.exports